/**
 * Frontend "Does Not Contain" Operator.
 *
 * Registers with the module registry to handle the `does_not_contain` operator.
 * Returns true when the source field's value does NOT contain the rule value
 * as a substring. Uses GF's native `contains` operator via gf_is_match() and
 * negates the result, ensuring consistent behavior with the PHP evaluation.
 *
 * @package
 */

import { registerModule } from './module-registry';

// Register with the module registry on import.
registerModule({
	slug: 'operator-does-not-contain',
	handles: (rule) => rule.operator === 'does_not_contain',
	evaluate: (_isMatch, formId, rule) => {
		// Delegate to GF's native 'contains' check and negate.
		// This ensures consistent DOM value reading with GF's own logic.
		const tempRule = {
			fieldId: rule.fieldId,
			operator: 'contains' as const,
			value: rule.value,
		};

		return !gf_is_match(formId, tempRule);
	},
});
